/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiCustomListSchemaFieldType {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    DATETIME = 'DATETIME',
    OBJECT = 'OBJECT',
    ENUM = 'ENUM'
}


export function instanceOfInternalApiCustomListSchemaFieldType(value: any): boolean {
    for (const key in InternalApiCustomListSchemaFieldType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiCustomListSchemaFieldType, key)) {
            if (InternalApiCustomListSchemaFieldType[key as keyof typeof InternalApiCustomListSchemaFieldType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiCustomListSchemaFieldTypeFromJSON(json: any): InternalApiCustomListSchemaFieldType {
    return InternalApiCustomListSchemaFieldTypeFromJSONTyped(json, false);
}

export function InternalApiCustomListSchemaFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListSchemaFieldType {
    return json as InternalApiCustomListSchemaFieldType;
}

export function InternalApiCustomListSchemaFieldTypeToJSON(value?: InternalApiCustomListSchemaFieldType | null): any {
    return value as any;
}

export function InternalApiCustomListSchemaFieldTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiCustomListSchemaFieldType {
    return value as InternalApiCustomListSchemaFieldType;
}

